<template>
  <div>
    <div class="content_ban">
      <img class="banner" :src="bannerObj.image" />
      <div class="banner_box">
        <div class="notice">
          <h3>{{obj.title}}</h3>
          <div class="content_words">{{ bannerObj.des }}</div>
          <!-- <div class="content_words">公司主营产品及服务包括:金属氧化物避雷器带电检测仪、数字式钳形伏安相位表、大型地网接地电阻测量仪、多通道波形记录仪、PT感应耐压试验电源、高压高稳定电源...</div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getBanner} from "@/api/information"
export default {
  props: {
    obj: {
      type: Object,
    },
    navType: {
      type:String,
      default:"1"
    },
  },
  data(){
    return{
       bannerObj:{},
       bannerTpye:['1','2','3','4','5','6','7','8','9','10'],
       bannrtype:'',
       userType:''
    }
  },
  created() {
    this.bannerTpye.forEach((item)=>{
       if(this.obj.personalType == item){
          this.bannrtype = item;
       }
    })
    this.getBanner();
  },
  methods:{
     getBanner(){
       let params = { 
         type:this.bannrtype,
         usertype:this.obj.roleType,
         companytype:''
       };
       getBanner(params).then(res=>{
          if(res.code == 0){
            res.page.list.forEach((item) =>{
              if(this.bannrtype == item.type){
                this.bannerObj = item;
              }
            })  
          }      
       })
       }
  }
};
</script>
<style scoped lang='less'>
// @import url('../assets/css/coment.css');
.content_ban {
  position: relative;
  /* width: 100%;
  background-image: url('../assets/images/banner.jpg')no-repeat center/cover; */
}

.banner {
  width: 100%;
  height: 399px;
  position: relative;
}

.baran {
  position: absolute;
  top: 77px;
  left: 0px;
  width: 45%;
  height: 244px;
}
.banner_box{
  position: absolute;
  top: 138px;
  left: 50%;
  width: 1080px;
  transform: translateX(-540px);
  height: 244px;
}
.notice {
  // position: absolute;
  // top:25%;
  // right: 11.1% !important;
  // @media screen and(min-width:1280px){
  //   right:10%;
  // }
  // @media screen and (min-width:1366px) {
  //   right:13.5% !important;
  // }
  // @media screen and (min-width:1600px) {
  //   right:11.1% !important;
  // }
 
  // margin-left: 23% !important;
  // margin-top: 60px;
  // @media (min-width: 1600px) {
  //   margin-left: 41% !important;
  // }
}
.notice h3 {
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  text-align: left;
}

.content_words {
  width: 376px;
  height: 63px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  line-height: 20px;
  opacity: 0.7;
  margin-top: 10px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/common/commBanner.vue